import html2canvas from "html2canvas";

export const ACORN_POSTER_WIDTH = 414;
const CAPTURE_SCALE = 2;

const MAIN_FONT_SIZES = [10, 11, 12, 13, 14, 15, 19, 22, 26, 30, 38];

function getMainFontsUrl() {
    const base = process.env.PUBLIC_URL || "";
    const prefix = base.endsWith("/") ? base.slice(0, -1) : base;
    return `${window.location.origin}${prefix}/fonts/1.ttf`;
}

export async function ensureAcornPosterFontsLoaded() {
    if (!document.fonts?.load) {
        return;
    }

    try {
        await Promise.race([
            Promise.all(MAIN_FONT_SIZES.map((size) => document.fonts.load(`${size}px MainFonts`))),
            document.fonts.ready,
            new Promise((resolve) => {
                window.setTimeout(resolve, 2500);
            }),
        ]);
    } catch {
        // Fallback stacks still render if the custom font is unavailable.
    }
}

function getPosterBackground(variant) {
    return variant === "editorial" ? "#f7f3ec" : "#fbfbfd";
}

function prepareAcornCloneForCapture(clonedDoc, clonedElement) {
    const style = clonedDoc.createElement("style");
    style.textContent = `
        @font-face {
            font-family: MainFonts;
            src: url("${getMainFontsUrl()}") format("truetype");
        }
        .acorn-quote-poster {
            width: ${ACORN_POSTER_WIDTH}px !important;
            max-width: none !important;
            margin: 0 !important;
            aspect-ratio: unset !important;
        }
    `;
    clonedDoc.head.appendChild(style);

    if (clonedElement) {
        clonedElement.style.width = `${ACORN_POSTER_WIDTH}px`;
        clonedElement.style.maxWidth = "none";
        clonedElement.style.aspectRatio = "unset";
        clonedElement.style.margin = "0";
    }
}

function applyAcornCaptureDimensions(element) {
    element.style.width = `${ACORN_POSTER_WIDTH}px`;
    element.style.maxWidth = `${ACORN_POSTER_WIDTH}px`;
    element.style.aspectRatio = "unset";
    element.style.margin = "0";
}

function restoreAcornCaptureDimensions(element, previous) {
    element.style.width = previous.width;
    element.style.maxWidth = previous.maxWidth;
    element.style.aspectRatio = previous.aspectRatio;
    element.style.margin = previous.margin;
}

export async function captureAcornQuotePoster(element, variant = "classic") {
    if (!element) {
        throw new Error("Acorn poster element is missing");
    }

    await ensureAcornPosterFontsLoaded();

    const previous = {
        width: element.style.width,
        maxWidth: element.style.maxWidth,
        aspectRatio: element.style.aspectRatio,
        margin: element.style.margin,
    };

    applyAcornCaptureDimensions(element);

    try {
        await new Promise((resolve) => {
            requestAnimationFrame(() => requestAnimationFrame(resolve));
        });

        return await html2canvas(element, {
            scale: CAPTURE_SCALE,
            backgroundColor: getPosterBackground(variant),
            useCORS: true,
            logging: false,
            scrollX: 0,
            scrollY: 0,
            windowWidth: ACORN_POSTER_WIDTH,
            onclone: prepareAcornCloneForCapture,
        });
    } finally {
        restoreAcornCaptureDimensions(element, previous);
    }
}
